module.exports = __webpack_public_path__ + "static/media/ors3.png.9bd954d4.jpg";